import { useEffect, useState } from 'react';

const STORAGE_KEY_BASE = 'STORED_STATE_';

const useStoredState = (name: string, defaultValue: any = undefined) => {
    const [value, setValue] = useState(defaultValue);

    const key = `${STORAGE_KEY_BASE}${name}`;

    useEffect(() => {
        const savedValue = localStorage.getItem(key);
        if (savedValue) {
            try {
                let parsedValue = JSON.parse(savedValue);

                if (typeof defaultValue === 'number') {
                    setValue(parseFloat(parsedValue));
                } else {
                    setValue(parsedValue);
                }
            } catch (ex) {
                console.error('Failed to load stored state', ex);
            }
        }
    }, []);

    const setNewValue = newValue => {
        setValue(newValue);
        localStorage.setItem(key, JSON.stringify(newValue));
    };

    return [value, setNewValue];
};

export default useStoredState;
